import {
  SALESBEEZ_CATEGORIES_API,
  SALESBEEZ_STATIC_IMAGE_BY_CATEGORY,
  buildSalesbeezImageMap,
} from "../config/salesbeezCategoryImages";

let cachedMap = null;
let cachePromise = null;

export async function fetchSalesbeezCategoryImages() {
  if (cachedMap) return cachedMap;
  if (cachePromise) return cachePromise;

  cachePromise = (async () => {
    try {
      const response = await fetch(SALESBEEZ_CATEGORIES_API, {
        method: "GET",
        mode: "cors",
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      cachedMap = {
        ...SALESBEEZ_STATIC_IMAGE_BY_CATEGORY,
        ...buildSalesbeezImageMap(Array.isArray(data) ? data : []),
      };
      return cachedMap;
    } catch (error) {
      console.warn("Salesbeez category images unavailable, using static map:", error);
      cachedMap = { ...SALESBEEZ_STATIC_IMAGE_BY_CATEGORY };
      return cachedMap;
    } finally {
      cachePromise = null;
    }
  })();

  return cachePromise;
}

export function getCachedSalesbeezCategoryImages() {
  return cachedMap;
}
